import { Component, Input, OnInit, HostListener } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatCardModule } from "@angular/material/card";

export interface Review {
  text: string;
  name: string;
  rating: number;
}

@Component({
  selector: "app-carousel",
  templateUrl: "./carousel.component.html",
  styleUrls: ["./carousel.component.scss"],
  standalone: true,
  imports: [CommonModule, MatCardModule],
})
export class CarouselComponent implements OnInit {
  @Input() reviews: Review[] = [];
  currentIndex = 0;
  itemsPerView = 2;

  ngOnInit() {
    this.calculateItemsPerView();
  }

  @HostListener("window:resize")
  onResize(): void {
    this.calculateItemsPerView();
  }

  calculateItemsPerView(): void {
    this.itemsPerView = window.innerWidth <= 767 ? 1 : 2;
    if (this.currentIndex > this.maxIndex) {
      this.currentIndex = this.maxIndex;
    }
  }

  get maxIndex(): number {
    return Math.ceil(this.reviews.length / this.itemsPerView) - 1;
  }

  getTransform(): string {
    return `translateX(-${this.currentIndex * 100}%)`;
  }

  getStarsArray(rating: number): number[] {
    return Array(rating).fill(0);
  }

  prev(): void {
    this.currentIndex =
      this.currentIndex === 0 ? this.maxIndex : this.currentIndex - 1;
  }

  next(): void {
    this.currentIndex =
      this.currentIndex === this.maxIndex ? 0 : this.currentIndex + 1;
  }
}
